module.exports = __webpack_public_path__ + "img/download_btn.46b0e95f.png";